<template>
    <a-modal
        :width="'55%'"
        v-model="updateBasicRule"
        :title="$t('supervise.editSuperviseRule')"
        :maskClosable="maskClosable"
        :confirmLoading="okLoading"
        @ok="handleOk">

        <div style="padding:20px;">
            <a-card v-if="ruleTemplate">
                <a-form-item :label="$t('supervise.locateFreqBase')" v-bind="formItemLayout">
                    <a-select size="small" :allowClear="true"   v-model="locateFreq" style="width:100%">
                        <a-select-option v-for="option in freqOptions" :key="option.key">{{option.label}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :label="$t('supervise.locateFreqBle')" v-bind="formItemLayout">
                    <a-select size="small" :allowClear="true"   v-model="locateFreqBle" style="width:100%">
                        <a-select-option v-for="option in freqOptionsBle" :key="option.key">{{option.label}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :label="$t('supervise.locateFreqGps')" v-bind="formItemLayout">
                    <a-select size="small" :allowClear="true"   v-model="locateFreqGps" style="width:100%">
                        <a-select-option v-for="option in freqOptionsGps" :key="option.key">{{option.label}}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :label="$t('supervise.autoAdjust')" v-bind="formItemLayout">
                    <a-switch size="small" v-model="ruleTemplate.autoAdjust"/>
                </a-form-item>

                <a-form-item :label="$t('supervise.customLocate')" v-bind="formItemLayout">
                    <a-switch size="small" :disabled="!ruleTemplate.locateFreq" v-model="specialFreqSetting"/>
                </a-form-item>

                <a-row>
                    <a-col span="22" v-if="specialFreqSetting && ruleTemplate.locateFreq" style="margin-bottom: 20px;margin-left:1%;">
                        <a-row :gutter="24" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;padding:10px">
                            <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-8px;margin-left:-10px">{{$t('supervise.customLocate')}}</a-divider>

                            <a-form-item :label="$t('supervise.segmentTime')" v-bind="formItemLayout" :validateStatus="specialTimeValidateStatus" :help="specialTimeErrorMessage">
                                <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%" format="HH:mm" v-model="startTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                                <a-input size="small" style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                                <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%" format="HH:mm" v-model="endTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                            </a-form-item>

                            <a-form-item :label="$t('supervise.segmentFreq')" v-bind="formItemLayout" :validateStatus="specialFreqValidateStatus" :help="specialFreqErrorMessage">
                                <a-select :allowClear="true" size="small" v-model="intervalTime" style="width:100%">
                                    <a-select-option v-for="option in freqOptions" :key="option.key">{{option.label}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-row>
                    </a-col>
                </a-row>

                <a-form-item :label="$t('supervise.autoPowerUp')" v-bind="formItemLayout" :validateStatus="powerUpValidateStatus" :help="powerUpValidateErrorMessage">
                    <a-time-picker  @change="onTimeChange" size="small" style="width:80%" format="HH:mm" v-model="powerUpTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                </a-form-item>

                <a-form-item :label="$t('supervise.autoPowerDown')" v-bind="formItemLayout" :validateStatus="powerDownValidateStatus" :help="powerDownValidateErrorMessage">
                    <a-time-picker @change="onTimeChange" size="small" style="width:80%" format="HH:mm" v-model="powerDownTime" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                </a-form-item>

                <a-form-item  :label="$t('supervise.applyChild')" v-bind="formItemLayout">
                    <a-checkbox v-model="applyAll"></a-checkbox>
                </a-form-item>

                <a-alert :message="$t('global.tips')" type="info" showIcon>
                    <p slot="description">
                        1：{{$t('supervise.powerTip')}}
                        <br/>
                        2：{{$t('supervise.applyChildTip')}}
                    </p>
                </a-alert>

            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import moment from 'moment'

    export default {
        name: 'ZUpdateBasicConfig',
        data() {
            return {
              okLoading: false,
                updateBasicRule: false,
                maskClosable: false,
                form: null,
                startTime: null,
                endTime: null,
                ruleTemplate: null,
                specialFreqSetting: false,
                specialModelFreqSetting:false,
                specialTimeValidateStatus: null,
                specialTimeErrorMessage:null,
                specialFreqValidateStatus: null,
                specialFreqErrorMessage : null,
                powerUpValidateStatus: null,
                powerUpValidateErrorMessage: null,
                powerDownValidateStatus: null,
                powerDownValidateErrorMessage: null,
                intervalTime: null,
                powerUpTime: null,
                powerDownTime: null,
                groupId: null,
                applyAll: false,
                locateFreq: 1800,
                // freqOptions: [
                //     {"key":300,"label":"5" + this.$t('global.minute')},
                //     {"key":600,"label":"10" + this.$t('global.minute')},
                //     {"key":900,"label":"15" + this.$t('global.minute')},
                //     {"key":1200,"label":"20" + this.$t('global.minute')},
                //     {"key":1800,"label":"30" + this.$t('global.minute')},
                //     {"key":2400,"label":"40" + this.$t('global.minute')},
                //     {"key":3600,"label":"60" + this.$t('global.minute')}
                // ],
                formItemLayout: {
                    labelCol: {
                        lg: { span: 24 },
                        xl: { span: 6 },
                        xxl: {span: 12}
                    },
                    wrapperCol: {
                        lg: { span: 24 },
                        xl: { span: 13 },
                        xxl: {span:12}
                    }
                },
                locateFreqSelect:false,
                locateFreqBle:1800,
                locateFreqGps:1800,
            }
        },
        computed: {
          freqOptions () {
            return [
                {"key":300,"label":"5" + this.$t('global.minute')},
                {"key":600,"label":"10" + this.$t('global.minute')},
                {"key":900,"label":"15" + this.$t('global.minute')},
                {"key":1200,"label":"20" + this.$t('global.minute')},
                {"key":1800,"label":"30" + this.$t('global.minute')},
                {"key":2400,"label":"40" + this.$t('global.minute')},
                {"key":3600,"label":"60" + this.$t('global.minute')}
            ]
          },
        freqOptionsBle () {
            return [
                {"key":5,"label":"5" + this.$t('global.second')},
                {"key":10,"label":"10" + this.$t('global.second')},
                {"key":15,"label":"15" + this.$t('global.second')},
                {"key":30,"label":"30" + this.$t('global.second')},
                {"key":60,"label":"1" + this.$t('global.minute')},
                {"key":300,"label":"5" + this.$t('global.minute')},
                {"key":600,"label":"10" + this.$t('global.minute')},
                {"key":1800,"label":"30" + this.$t('global.minute')}
            ]
        },
        freqOptionsGps () {
            return [
                {"key":5,"label":"5" + this.$t('global.second')},
                {"key":10,"label":"10" + this.$t('global.second')},
                {"key":20,"label":"20" + this.$t('global.second')},
                {"key":30,"label":"30" + this.$t('global.second')},
                {"key":60,"label":"1" + this.$t('global.minute')},
                {"key":300,"label":"5" + this.$t('global.minute')},
                {"key":600,"label":"10" + this.$t('global.minute')},
                {"key":1800,"label":"30" + this.$t('global.minute')},
                {"key":2400,"label":"40" + this.$t('global.minute')},
                {"key":3600,"label":"60" + this.$t('global.minute')}
            ]
        }
        },
        methods: {
            onTimeChange(selectTime){
                if(selectTime){
                    selectTime = moment(selectTime.startOf('minute').valueOf())
                }
            },
            handleOk(){
              this.okLoading = true
                let updateParam = {}
                updateParam.id = this.ruleTemplate.id
                updateParam.locateFreq = this.locateFreq
                updateParam.autoAdjust = this.ruleTemplate.autoAdjust || false
                updateParam.applyAll = this.applyAll

                let _this = this
                if(this.locateFreq){
                    updateParam.locateFreq = this.locateFreq
                    updateParam.locateFreqBle = this.locateFreqBle
                    updateParam.locateFreqGps = this.locateFreqGps
                    if(this.specialFreqSetting){
                        let customLocateModel = {}
                        if(this.startTime == null || this.endTime == null){
                            this.specialTimeValidateStatus = 'error'
                            this.specialTimeErrorMessage = '请选择时间区间'
                            setTimeout(function(){
                                _this.specialTimeValidateStatus = "success"
                                _this.specialTimeErrorMessage = null
                            },5000)
                            return;
                        }
                        if(!this.intervalTime){
                            this.specialFreqValidateStatus = 'error'
                            this.specialFreqErrorMessage = '请选择定位频率'
                            setTimeout(function(){
                                _this.specialFreqValidateStatus = "success"
                                _this.specialFreqErrorMessage = null
                            },5000)
                            return;
                        }

                        customLocateModel.startTime =  this.startTime.hour() * 3600 + this.startTime.minute() * 60
                        customLocateModel.endTime =  this.endTime.hour() * 3600 + this.endTime.minute() * 60
                        customLocateModel.intervalTime = this.intervalTime
                        updateParam.customLocate = []
                        updateParam.customLocate.push(customLocateModel)
                    }
                }

                if(this.powerUpTime){
                    if(!this.powerDownTime){
                        this.powerDownValidateStatus = 'error'
                        this.powerDownValidateErrorMessage = '请选择定时关机时间'
                        setTimeout(function(){
                            _this.powerDownValidateStatus = "success"
                            _this.powerDownValidateErrorMessage = null
                        },5000)
                        return;
                    }
                    updateParam.autoPowerUp = this.powerUpTime.hour() * 3600 + this.powerUpTime.minute() * 60
                }
                if(this.powerDownTime){
                    if(!this.powerUpTime){
                        this.powerUpValidateStatus = 'error'
                        this.powerUpValidateErrorMessage = '请选择定时开机时间'
                        setTimeout(function(){
                            _this.powerUpValidateStatus = "success"
                            _this.powerUpValidateErrorMessage = null
                        },5000)
                        return;
                    }
                    updateParam.autoPowerDown = this.powerDownTime.hour() * 3600 + this.powerDownTime.minute() * 60
                }
                // console.log(updateParam)
                this.$http.put(config.api.rule_template_basic_url,updateParam).then((response) => {
                  this.okLoading = false
                    if(response.code == 0){
                        _this.updateBasicRule = false
                        // _this.$message.success('修改成功')
                        this.$notification.success({
                          message: this.$t('global.commitSuccess')
                        })
                        _this.$emit("updateSuccess",this.groupId)
                    } else {
                        _this.$message.error(response.desc)
                    }
                })
            },
            showModel(template,groupId){
                // console.log(template)
                this.ruleTemplate = template
                this.locateFreq = this.ruleTemplate.locateFreq
                this.locateFreqBle = this.ruleTemplate.locateFreqBle
                this.locateFreqGps = this.ruleTemplate.locateFreqGps
                this.groupId = groupId
                //this.specialModelFreqSetting = template.locateFreqBle && template.locateFreqGps
                if(template.customLocate.length > 0){
                    this.specialFreqSetting = true
                    this.intervalTime = template.customLocate[0].intervalTime
                    this.startTime = moment(parseInt(moment().startOf('day').valueOf()) + template.customLocate[0].startTime * 1000)
                    this.endTime = moment(parseInt(moment().startOf('day').valueOf()) + template.customLocate[0].endTime * 1000)
                }else{
                    this.specialFreqSetting = false
                    this.intervalTime = null
                    this.startTime = null
                    this.endTime = null
                }
                if(template.autoPowerUp){
                    this.powerUpTime = moment(parseInt(moment().startOf('day').valueOf()) + template.autoPowerUp * 1000)
                }
                if(template.autoPowerDown){
                    this.powerDownTime = moment(parseInt(moment().startOf('day').valueOf()) + template.autoPowerDown * 1000)
                }
                if(!template.locateFreq) {
                  this.ruleTemplate.locateFreq = 1800
                  this.locateFreq = this.ruleTemplate.locateFreq
                }
                this.updateBasicRule = true
            }
        }
    }
</script>
